export default __webpack_public_path__ + "static/media/todo.6fd07079.png";